// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3320":"d984b6d41ed7b351","9669":"5e1c2c4a1a12a598"}[chunkId] + ".js";
};